export default {
      id: "rupee-usage",
      viewBox: "0 0 118 116",
      url: __webpack_public_path__ + "sprite.svg#rupee",
      toString: function () {
        return this.url;
      }
    }